export enum CHECKOUT_ROUTES {
  DELIVERY = '/delivery',
  COMPLETE = '/complete',
  PAYMENT = '/payment',
  CASH_APP_PAY = '/cash_app_pay',
}

export enum CompleteOrderError {
  GENERIC = 'generic',
  PAYMENT = 'payment',
  PRE_AUTH = 'pre_auth',
}
